<template>
  <!-- Simulador de Crédito Dialog -->
  <v-dialog v-model="viewModel.dialog.value" persistent max-width="800px">
    <v-card>
      <!-- Title Section -->
      <v-card-title class="d-flex justify-between align-center">
        <span class="text-subtitle-1 font-weight-bold"
          >Simulador de Crédito</span
        >
        <v-spacer></v-spacer>
        <v-btn variant="flat" icon @click="viewModel.closeDialog()">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-divider></v-divider>

      <!-- Credit Simulation Form -->
      <v-card-text>
        <v-container class="pa-0">
          <v-row dense>
            <v-col cols="12" class="text-center">
              <v-card-title class="text-subtitle-1 font-weight-bold"
                >Cuota Mensual</v-card-title
              >
              <v-card-text class="text-h4 font-weight-bold">
                S/
                {{ viewModel.monthlyPayment.value?.toFixed(2) ?? 0 }}
              </v-card-text>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="12" md="6">
              <v-text-field
                v-model="viewModel.amount.value"
                label="Monto del Crédito (S/)"
                variant="outlined"
                type="number"
                :rules="viewModel.amountRules"
                required
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-menu
                v-model="viewModel.paymentDateMenu.value"
                transition="scale-transition"
                offset-y
              >
                <template #activator="{ props }">
                  <v-text-field
                    v-model="viewModel.formattedPaymentDate.value"
                    label="Hoy"
                    variant="outlined"
                    v-bind="props"
                    readonly
                    required
                  ></v-text-field>
                </template>
              </v-menu>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="12" md="6">
              <v-select
                v-model="viewModel.installments.value"
                :items="viewModel.installmentOptions"
                label="Número de Cuotas"
                variant="outlined"
                required
                :rules="viewModel.installmentRules"
              ></v-select>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                v-model="viewModel.rate.value"
                label="Tasa de Interés (%)"
                variant="outlined"
                type="number"
                :rules="viewModel.rateRules"
                required
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="12">
              <v-btn
                height="50"
                block
                color="primary"
                @click="viewModel.calculateSimulation()"
                :disabled="!viewModel.isFormValid"
              >
                Simular Crédito
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script setup lang="ts">
import { defineExpose } from "vue";
import CreditSimulatorViewModel from "@/viewmodels/dialogs/CreditSimulatorViewModel";

const viewModel = new CreditSimulatorViewModel();

defineExpose({
  openDialog: () => viewModel.openDialog(),
  closeDialog: () => viewModel.closeDialog(),
  closeMenu: () => viewModel.closeMenu(),
});
</script>
